import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";
import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/organizations")({
  component: RouteComponent,
  beforeLoad() {
    // organizations requires a justification session
    ensureSession();
  },
});

function RouteComponent() {
  return (
    <PermissionGuard permission="orgs:view">
      <Outlet />
    </PermissionGuard>
  );
}
